import React, { useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { DESKTOP_TYPE_PADDING_DIVIDER, MOBILE_TYPE_PADDING_DIVIDER } from '../../../constants/carousels';
import { channelPropTypes } from '@/modules/common/constants/propTypes';

import * as commonSelectors from '../../../../common/redux/selectors/common';
import { slideDimensions } from '../../../helpers/carousel';
import { getMainWidth, IsInPopupContext, RootContainers } from '@/modules/common/helpers';
import { useSmallScreen } from '@/modules/common/helpers/customHooks';
import { getDummyList } from '@/modules/common/helpers/object';

import { Skeleton as SlideSkeleton } from '../Slide/Slide';

import styles from './CarouselSkeleton.module.scss';

function CarouselSkeleton(props) {
  const isInPopup = useContext(IsInPopupContext);
  const popupSize = useSelector(commonSelectors.popupSizeSelector);

  const wrapperRef = useRef(null);
  const contentRef = useRef(null);

  const [mainContainerWidth, setMainContainerWidth] = useState(getMainWidth(isInPopup, popupSize));

  const isSmallScreen = useSmallScreen();

  const padding = isSmallScreen ? MOBILE_TYPE_PADDING_DIVIDER : DESKTOP_TYPE_PADDING_DIVIDER;

  useEffect(() => {
    const parentSubscription = isInPopup ? window : RootContainers.getRootContainer();

    const fn = () => setMainContainerWidth(getMainWidth(isInPopup, popupSize));

    fn();

    parentSubscription.addEventListener('resize', fn);

    return () => {
      parentSubscription.removeEventListener('resize', fn);
    };
  }, [isInPopup, popupSize]);

  const dimensions = slideDimensions(props.channel.design, props.channel.format, mainContainerWidth);

  const shiftSize = dimensions.width + padding;

  const children = getDummyList(Math.max(1, Math.ceil(mainContainerWidth / shiftSize)));

  const carouselWidth = children.length * shiftSize - padding;

  return (
    <div ref={wrapperRef} className={styles.Wrapper}>
      <div
        ref={contentRef}
        tabIndex={-1}
        role="button"
        className={styles.Content}
        style={{
          width: carouselWidth,
        }}
      >
        {children.map((key) => (
          <div
            key={key}
            className={styles.Slide}
            style={{
              width: dimensions.width,
            }}
          >
            <SlideSkeleton key={key} width={dimensions.width} height={dimensions.height} />
          </div>
        ))}
      </div>
    </div>
  );
}

CarouselSkeleton.propTypes = {
  channel: channelPropTypes.isRequired,
};

export default CarouselSkeleton;
